import { useEffect, useState } from 'react';

interface Countdown {
  hours: string;
  minutes: string;
  seconds: string;
}

const pad = (value: number) => value.toString().padStart(2, '0');

export function useCountdown(hoursFromNow: number = 24): Countdown {
  const [target] = useState(() => Date.now() + hoursFromNow * 60 * 60 * 1000);
  const [remainingMs, setRemainingMs] = useState(() => Math.max(target - Date.now(), 0));

  useEffect(() => {
    const interval = setInterval(() => {
      setRemainingMs(Math.max(target - Date.now(), 0));
    }, 1000);
    return () => clearInterval(interval);
  }, [target]);

  const totalSeconds = Math.floor(remainingMs / 1000);
  const hours = Math.floor(totalSeconds / 3600);
  const minutes = Math.floor((totalSeconds % 3600) / 60);
  const seconds = totalSeconds % 60;

  return {
    hours: pad(hours),
    minutes: pad(minutes),
    seconds: pad(seconds)
  };
}
